module.exports = __webpack_public_path__ + "static/media/quiz.6958f815.svg";